import axios from "axios";
import store from "@/redux/store";
import { logout, setTokens } from "@/redux/slices/userSlice";
import { attachInterceptors } from "./interceptor";

const API_BASE_URL = "https://ilosiwaju-mbaay-2025.com/api/v1/user";

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach interceptors using the shared utility
attachInterceptors(
  api,
  store,
  (state) => state.user.token,
  (state) => state.user.refreshToken,
  setTokens,
  logout,
  `${API_BASE_URL}/refresh_token`,
);

export const fetchUserProfile = async (token: string) => {
  try {
    const response = await api.get("/get-one-user", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch user profile",
    );
  }
};
export const createUser = async (userData: any) => {
  try {
    const response = await api.post("/create_user", userData);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Failed to create account",
    );
  }
};

// OTP Verification API Call
export const verifyOtp = async (userId: string, otp: string) => {
  try {
    const response = await api.post(`/verify-otp/${userId}`, { otp });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Invalid OTP");
  }
};

// Resend OTP API Call
export const resendOtp = async (userId: string) => {
  try {
    const response = await api.post(`/resend-otp/${userId}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to resend OTP");
  }
};

export const LoginUser = async (userData: any) => {
  try {
    const response = await api.post("/login-user", userData);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Login failed. Please try again.");
  }
};

// Best-effort server-side logout. Uses a plain axios call (NOT the intercepted
// `api` instance) so an expired access token can't trigger a token refresh
// during an intentional logout. Failures are swallowed — the client always
// clears its own session afterwards.
export const logoutUser = async (token?: string | null) => {
  try {
    await axios.post(
      `${API_BASE_URL}/logout`,
      {},
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
    );
  } catch {
    // Ignore — logout must always succeed on the client regardless.
  }
};

// User Forgot Password - sends OTP to email
export const forgotPasswordUser = async (email: string) => {
  try {
    const response = await api.post("/forgotpassword_user", { email });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to send reset OTP");
  }
};

// User Reset Password - verify OTP and set new password
export const resetPasswordUser = async (
  email: string,
  otp: string,
  newPassword: string
) => {
  try {
    const response = await api.post("/resetpassword_user", { email, otp, newPassword });
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to reset password");
  }
};
